import * as Preact from "preact"
import "@fae/source/views/components/EditorModeSplash.less"

export default class EditorModeSplash {
    render() {
        return (
            <div class="EditorModeSplash">
                <div class="ModeText">
                    {this.props.text}
                </div>
            </div>
        )
    }
}
